module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-form": "frmCategorizers"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('vetor')
    },
    attrs: {
      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Vetor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_vetor),
      expression: "propsAnalise.ds_categ_vetor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vetor",
      "aria-hidden": "true",
      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_prjvet))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_vetor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'VETOR'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('vetor')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('vetor')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('ação')
    },
    attrs: {
      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_acao),
      expression: "propsAnalise.ds_categ_acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vetor",
      "aria-hidden": "true",
      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_acao))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'ACAO'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('ação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('ação')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('tecnologia')
    },
    attrs: {
      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tecnologia")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_tecnologia),
      expression: "propsAnalise.ds_categ_tecnologia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tecnologia",
      "aria-hidden": "true",
      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_tecno))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_tecnologia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'TECNOLOGIA'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('tecnologia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tecnologia')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'top',
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, placement:'top', animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('campo de atuação')
    },
    attrs: {
      "title": '<h5>Definido pelo projeto duplicador ' + this.propsAnalise.duplicadorSapiens.numprj + ' selecionado</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Campo de Atuação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_campo_atuacao),
      expression: "propsAnalise.ds_categ_campo_atuacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "campo de atuação",
      "aria-hidden": "true",
      "disabled": !_vm._.isEmpty(_vm._.trim(_vm.propsAnalise.duplicadorSapiens.usu_campatu))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_campo_atuacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'CAMPOS_DE_ATUACAO'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('campo de atuação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('campo de atuação')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('prospecção')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Prospecção")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_prospeccao),
      expression: "propsAnalise.ds_categ_prospeccao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "prospecção",
      "aria-hidden": "true",
      "disabled": false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_prospeccao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'PROSPECCAO'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('prospecção')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('prospecção')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [(!_vm.ehSimplificada) ? _c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('avaliação')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Avaliação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indicativoAvaliacao),
      expression: "indicativoAvaliacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "prospecção",
      "aria-hidden": "true",
      "disabled": true
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.indicativoAvaliacao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Preencha o questionário abaixo")]), _vm._v(" "), _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'AVALIACAO'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  })], 2), _vm._v(" "), (_vm.errors.first('avaliação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('avaliação')))]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('programa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Programa")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_programa),
      expression: "propsAnalise.ds_categ_programa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "programa",
      "aria-hidden": "true",
      "disabled": false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_programa", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'PROGRAMA'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('programa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('programa')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('instrumento')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Instrumento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_instrumento),
      expression: "propsAnalise.ds_categ_instrumento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "instrumento",
      "aria-hidden": "true",
      "disabled": false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_instrumento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'INSTRUMENTO'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('instrumento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('instrumento')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('atividades')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cadeias Produtivas/Atividades")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_atividade),
      expression: "propsAnalise.ds_categ_atividade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "atividades",
      "aria-hidden": "true",
      "disabled": false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_atividade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'CADEIAS_PRODUTIVAS'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('atividades')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('atividades')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('edital')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Edital")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_categ_edital),
      expression: "propsAnalise.ds_categ_edital"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "edital",
      "aria-hidden": "true",
      "disabled": false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_categ_edital", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.categorizadores, ['grupo', 'EDITAL'])), function(categorizador) {
    return _c('option', {
      domProps: {
        "value": categorizador.valor
      }
    }, [_vm._v(_vm._s(categorizador.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('edital')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('edital')))]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('legend', [_vm._v(" Categorizadores")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69cc101f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/categorizadores.vue
// module id = 1895
// module chunks = 2